exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tooltip__content[data-v-52ae5c76]{top:810px!important}", ""]);

// exports
